import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  BooleanInput,
  BooleanField,
  Show,
  SimpleShowLayout,
  Edit,
  SimpleForm,
  Create,
  NumberInput,
  regex,
} from "react-admin";

const validateStockID = regex(/^\s*\d+\s*(,\s*\d+\s*)*\s*$/, "Must be a comma separated list 123,456");

export const UserList = (props) => (
  <List {...props} title="Пользователи">
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <TextField source="email" label="Пользователь" />
      <BooleanField source="is_admin" label="Админ" />
      <TextField source="UserInfo.name" label="Имя" />
      <TextField source="UserInfo.phone" label="Телефон" />
      <TextField source="UserInfo.supplier_id" label="Номер поставщика" />
      <TextField source="UserInfo.online_shop_id" label="Магазин" />
      <TextField
        source="UserInfo.online_stock_id"
        label="Остатки по магазинам"
      />
      <TextField
        source="UserInfo.casa_user"
        label="Имя для вебкассы"
      />
      <TextField
        source="UserInfo.casa_pass"
        label="Пароль для вебкассы"
      />
    </Datagrid>
  </List>
);

export const UserShow = (props) => (
  <Show {...props} title="Пользователь">
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="email" label="Пользователь" />
      <BooleanField source="is_admin" label="Админ" />
      <TextField source="UserInfo.name" label="Имя" />
      <TextField source="UserInfo.phone" label="Телефон" />
      <TextField source="UserInfo.supplier_id" label="Номер поставщика" />
      <TextField
        source="UserInfo.online_shop_id"
        label="Номер онлайн магазина"
      />
      <TextField
        source="UserInfo.online_stock_id"
        label="Остатки по магазинам"
      />
      <TextField
        source="UserInfo.casa_user"
        label="Имя для вебкассы"
      />
      <TextField
        source="UserInfo.casa_pass"
        label="Пароль для вебкассы"
      />
    </SimpleShowLayout>
  </Show>
);

export const UserEdit = (props) => (
  <Edit {...props} title="Пользователь">
    <SimpleForm>
      <TextField disabled source="id" label="ID" />
      <TextInput source="email" label="Пользователь" />
      <TextInput source="password" label="Пароль" />
      {/* <TextInput source="is_admin" label="Админ" /> */}
      <BooleanInput source="is_admin" label="Админ" />
      <TextInput source="UserInfo.name" label="Имя" />
      <TextInput source="UserInfo.phone" label="Телефон" />
      <NumberInput source="UserInfo.supplier_id" label="Номер поставщика" />
      <NumberInput
        source="UserInfo.online_shop_id"
        label="Номер онлайн магазина"
      />
      <TextInput
        source="UserInfo.online_stock_id"
        label="Остатки по магазинам"
        validate={validateStockID}
      />
      <TextInput
        source="UserInfo.casa_user"
        label="Имя для вебкассы"
      />
      <TextInput
        source="UserInfo.casa_pass"
        label="Пароль для вебкассы"
      />
    </SimpleForm>
  </Edit>
);

export const UserCreate = (props) => (
  <Create {...props} title="Пользователь">
    <SimpleForm>
      <TextInput source="email" label="Пользователь" />
      <TextInput source="password" label="Пароль" />
      <BooleanInput source="is_admin" label="Админ" defaultValue={false} />
      <TextInput source="UserInfo.name" label="Имя" />
      <TextInput source="UserInfo.phone" label="Телефон" />
      <NumberInput source="UserInfo.supplier_id" label="Номер поставщика" />
      <TextInput
        source="UserInfo.online_stock_id"
        label="Остатки по магазинам"
        validate={validateStockID}
      />
    </SimpleForm>
  </Create>
);
